import { getTimeFromUTCToTimezone } from '../../../shared/utils/getTimeFromUTCToTimezone';
import { formateNumber } from 'shared/helpers';

export class UserApiConverter {
  convertUsersList = (data, additionalData) => {
    const { source_user, users } = data;
    const parent = {
      ...source_user,
      isParent: true,
      parent_agent: {
        balance: formateNumber(source_user?.balance),
        id: source_user?.id,
        username: source_user?.username,
        role: 6,
      },
    };

    const fullUsers = [{ ...parent }, ...users].filter(i => i.id);

    const userList = fullUsers.map(el => {
      return {
        balance: formateNumber(el.balance),
        id: el.id,
        isBanned: el.is_banned,
        role: el.role,
        commissionPercent: el.commission_percent || null,
        username: el.username,
        creationDate: getTimeFromUTCToTimezone(el.creation_date)?.format('DD.MM.YYYY'),
        totalDeposits: el.total_deposits,
        parentAgent: {
          balance: formateNumber(el.parent_agent.balance),
          id: el.parent_agent.id,
          username: el.parent_agent.username,
        },
        isCashbackActive: el.is_cashback_active,
      };
    });

    return {
      users: userList,
      totalCount: /* formateNumber */ data.total_count || 0,
      balanceSum: formateNumber(data.balance_sum) || 0,
    };
  };

  convertNewPassword = data => data.new_password;

  convertUserInfo = data => {
    return {
      id: data.user.id,
      commissionPercent: data.commission_percent,
      name: data.user.first_name,
      surname: data.user.last_name,
      username: data.user.username,
      email: data.user.email,
      role: data.user.role,
      balance: formateNumber(data.user.balance),
      bonusBalance: formateNumber(data.user.bonus_balance),
      currency: data.user.currency,
      parentAgentId: data.user.parent_agent_id,
      structurePath: data.user.structure_path,
      note: data.user.note,
      isBanned: data.user.is_banned,
      isVisible: data.user.is_visible,
      isDepositAccess: data.user?.is_deposit_access ?? true,
      isWithdrawalAccess: data.user.is_withdrawal_access,
      firstVisit:
        data.user.first_visit.length === 0 ? '' : getTimeFromUTCToTimezone(data.user.first_visit)?.format('DD/MM/YYYY'),
      lastVisit:
        data.user.last_visit.length === 0 ? '' : getTimeFromUTCToTimezone(data.user.last_visit)?.format('DD/MM/YYYY'),
      structure: data.structure,
      updatedAt: getTimeFromUTCToTimezone(data.user.updated_at)?.format('DD/MM/YYYY HH:mm:ss'),
      ipList: data.ip_list,
      canCreateOnlyPlayer: data.user?.can_create_only_player,
    };
  };

  convertBannedProviders = data => ({
    blocklist: data.blocklist.length ? data.blocklist : [],
    semiAutoWithdrawalEnabled: data.semi_auto_withdrawal_enabled,
    isVisibleFeedbackLink: data.is_visible_feedback_link,
  });

  convertBannedProvidersSet = data => {
    if (data.blocklist) {
      return data.blocklist.length ? data.blocklist : [];
    } else {
      return data.length ? data : [];
    }
  };

  convertProfileInfo = data => data;
}
